import React, { useCallback, useRef } from 'react';
import { View } from 'react-native';
import { Typography } from '@hmsexp/component-library';
import styles from "./style"
import useTransformPieChartData from './hooks/useTransformPieChartData';
import MultiFeatureCard from '../../Card/MultiOptionsCard/MultiFeatureCard';
import PieChartContainer from './PieChartContainer';
import LowerSampleSizeFooter from '../../LowerSampleSizeFooter';
import { handleHighChartsExport } from '../../../../containers/Overview/utils';

const PieChartWidget = ({ item, timeperiodLabel,actionMenuData=[], onChartClick }) => {

    const {
        value,
        subLabel,
        options,
        isLowSampleSize,
        lowSampleSize,
        pieChartSubtitle,

    } = useTransformPieChartData(item, timeperiodLabel);
    const chartRef = useRef(null);

    const pieChartTooltip = useCallback((scoreSize) => {
        return (
            <View style={styles.pieChartContainer}>
                <Typography textProps={{ style: styles.tooltipValue }} variant='button' color='white'>
                    {scoreSize}
                </Typography>
                <Typography textProps={{ style: styles.tooltipLabel }} variant='button' color='white'>
                    {timeperiodLabel}
                </Typography>
            </View>
        );
    }, [styles, timeperiodLabel]);

    function actionButtonClick(e) {
        handleHighChartsExport(e, chartRef, item);
    }

    return (
        <MultiFeatureCard
            title={item?.title}
            subTitle={pieChartSubtitle}
            actionMenu={actionMenuData}
            onActionButtonClick={actionButtonClick}
            renderContent={(activeSwitch, contentRef) => (
                <PieChartContainer
                    isLowSampleSize={isLowSampleSize}
                    value={value}
                    onChartClick={e => onChartClick && onChartClick(e, { ...item, subTitle: pieChartSubtitle })}
                    data={item}
                    options={options}
                    ref={chartRef}
                    activeSwitch={activeSwitch}
                    tooltipComponent={() => pieChartTooltip(subLabel)}
                />
            )}
            enableActionBtn={item?.enableActionBtn}
            style={{ childContainer: { paddingVertical: 20, paddingTop: 40 } }}
            enableSwitchTab={item?.enableSwitchTab}
            switchOptions={item?.switchOptions}
            renderFooter={() => (
                <View>
                    {isLowSampleSize && <LowerSampleSizeFooter size={lowSampleSize} />}
                    <Typography fontWeightType='regular' variant='button'>
                        {item?.footerText}
                    </Typography>
                </View>
            )}
        />
    );
};

export default PieChartWidget;